import React from "react";
import { motion } from "framer-motion";
import portfolio from "@/data/portfolio";

export default function Skills() {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="py-24 md:py-40 border-t hairline bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mb-14 md:mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-block w-8 h-px bg-black/40" />
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
              06 · Expertise
            </span>
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-black leading-[1.05]">
            Experience across events, media, business development and equestrian sport.
          </h2>
          <p className="mt-7 text-lg text-gray-700 font-light leading-relaxed max-w-3xl">
            Over two decades working across international competition, event
            management, sponsorship, media rights, league development and
            technology-led ventures within the equestrian industry.
          </p>
        </div>

        <div className="flex flex-wrap gap-2.5 md:gap-3">
          {portfolio.skills.map((s, i) => (
            <motion.span
              key={s}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.03 }}
              data-testid={`skill-tag-${i}`}
              className="rounded-full bg-[#F5F5F7] border hairline px-5 py-2.5 text-sm text-gray-800 hover:border-black hover:bg-white transition-all"
            >
              {s}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
